import {
  FETCH_INSIDER_ATTACK_DETAILS, FETCH_INSIDER_ATTACK_DETAILS_FAIL, FETCH_INSIDER_ATTACK_DETAILS_SUCCESS,
  FETCH_INSIDER_ATTACK_OPTIONS,
  FETCH_INSIDER_ATTACK_OPTIONS_FAIL,
  FETCH_INSIDER_ATTACK_OPTIONS_SUCCESS,
  FETCH_REQUESTED_ATTACKS,
  FETCH_REQUESTED_ATTACKS_FAIL,
  FETCH_REQUESTED_ATTACKS_SUCCESS,
  POST_NEW_REQUESTED_ATTACK,
  POST_NEW_REQUESTED_ATTACK_FAIL,
  POST_NEW_REQUESTED_ATTACK_SUCCESS,
} from "../constants/ActionTypes";

const INIT_STATE = {
  attackPackages: null,
  loadingAttackPackages: false,
  loadingAttackPackagesFail: false,
  requestedAttacks: null,
  loadingRequestedAttacks: false,
  loadingRequestedAttacksFail: false,
  loadingRequestedAttackDetails: false,
  loadingRequestedAttackDetailsFail: false,
  loadingPostNewRequestedAttack: {},
  loadingPostNewRequestedAttackFail: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    /***********************************
     * FETCH_AOD_ATTACK_OPTIONS
     ***********************************/

    case FETCH_INSIDER_ATTACK_OPTIONS: {
      return {
        ...state,
        loadingAttackPackages: true,
        loadingAttackPackagesFail: false
      }
    }

    case FETCH_INSIDER_ATTACK_OPTIONS_SUCCESS: {
      return {
        ...state,
        attackPackages: {
          ...state.attackPackages,
          ...action.payload.packages
        },
        loadingAttackPackages: false,
        loadingAttackPackagesFail: false
      }
    }

    case FETCH_INSIDER_ATTACK_OPTIONS_FAIL: {
      return {
        ...state,
        loadingAttackPackages: false,
        loadingAttackPackagesFail: true
      }
    }

      /***********************************
       * FETCH_REQUESTED_ATTACKS
       ***********************************/

    case FETCH_REQUESTED_ATTACKS: {
      return {
        ...state,
        loadingRequestedAttacks: true,
        loadingRequestedAttacksFail: false
      }
    }

    case FETCH_REQUESTED_ATTACKS_SUCCESS: {
      return {
        ...state,
        requestedAttacks: {
          ...state.requestedAttacks,
          [action.payload.customerId]: action.payload.statusRequested
        },
        loadingRequestedAttacks: false,
        loadingRequestedAttacksFail: false
      }
    }

    case FETCH_REQUESTED_ATTACKS_FAIL: {
      return {
        ...state,
        loadingRequestedAttacks: false,
        loadingRequestedAttacksFail: true
      }
    }

      /***********************************
       * FETCH_INSIDER_ATTACK_DETAILS
       ***********************************/

    case FETCH_INSIDER_ATTACK_DETAILS: {
      return {
        ...state,
        loadingRequestedAttackDetails: true,
        loadingRequestedAttackDetailsFail: false
      }
    }

    case FETCH_INSIDER_ATTACK_DETAILS_SUCCESS: {

      //replace/overwrite the given attack with this one, which is presumed to have more information
      const inboundAttackId = action.payload.attackId;
      const customerId = action.payload.customerId;
      const newAttackObject = action.payload.inboundData;

      return {
        ...state,
        requestedAttacks: {
          ...state.requestedAttacks,
          [customerId]: {
            ...state.requestedAttacks[customerId],
            [inboundAttackId]: newAttackObject
          }
        },
        loadingRequestedAttackDetails: false,
        loadingRequestedAttackDetailsFail: false
      }
    }

    case FETCH_INSIDER_ATTACK_DETAILS_FAIL: {
      return {
        ...state,
        loadingRequestedAttackDetails: false,
        loadingRequestedAttackDetailsFail: true
      }
    }

      /***********************************
       * POST_NEW_REQUESTED_ATTACK
       ***********************************/

    case POST_NEW_REQUESTED_ATTACK: {
      return {
        ...state,
        loadingPostNewRequestedAttack: {
          ...state.loadingPostNewRequestedAttack,
          [action.payload.attackPackageId] : true,
        },
        loadingPostNewRequestedAttackFail: {
          ...state.loadingPostNewRequestedAttackFail,
          [action.payload.loadingPostNewRequestedAttackFail] : false,
        },
      }
    }

    case POST_NEW_REQUESTED_ATTACK_SUCCESS: {
      const newAttackObject = action.payload.inboundData;
      //add a frontend flag so that during this session, the row is marked as being "new"
      newAttackObject["BB_FRONTEND_FLAG__JUST_ADDED"] = true;

      return {
        ...state,
        // add the returned attack object to the state
        requestedAttacks: {
          ...state.requestedAttacks,
          [action.payload.customerId]: {
            ...state.requestedAttacks[action.payload.customerId],
            [action.payload.inboundData.AttackId]: newAttackObject,
          }
        },
        loadingPostNewRequestedAttack: {
          ...state.loadingPostNewRequestedAttack,
          [action.payload.attackPackageId] : false,
        },
        loadingPostNewRequestedAttackFail: {
          ...state.loadingPostNewRequestedAttackFail,
          [action.payload.loadingPostNewRequestedAttackFail] : false,
        },
      }
    }

    case POST_NEW_REQUESTED_ATTACK_FAIL: {
      return {
        ...state,
        loadingPostNewRequestedAttack: {
          ...state.loadingPostNewRequestedAttack,
          [action.payload.attackPackageId] : false,
        },
        loadingPostNewRequestedAttackFail: {
          ...state.loadingPostNewRequestedAttackFail,
          [action.payload.loadingPostNewRequestedAttackFail] : true,
        },
      }
    }

    default:
      return state;
  }
}
